import FieldDefs from './AdKeysFieldDefs.js'
import {doLangFields} from '../../lib/ks-tools'

export default {
    template: `<div><slot v-bind="self" /></div>`,
    data() {
        return {
            fields: doLangFields(this, "lang.report.direct-ad-keys", FieldDefs),
            sortOrder: [
                {
                    field: 'ads_count',
                    direction: 'desc'
                }
            ],
            additionalActions: []
        }
    },
    computed: {
        self() {
            return this;
        },
    },
}
